import Axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import QueryString from "query-string"

export const requestPermissions = async () => {
  try {
    let data = await Axios.get("/api/permission/getPermission")
    return data
  } catch (error) {
    throw error
  }
}

export const requestPermissionsByRoleCode = async ({ payload }) => {
  try {
    let data = await Axios.get(
      `/api/permission/getPermissionsByRoleCode?roleCode=${payload.roleCode}`
    )
    return data
  } catch (error) {
    throw error
  }
}

export const requestUpsertPermission = async payload => {
  const { action } = payload.query
  try {
    if (action === "create") {
      const data = await Axios.post(
        `/api/permission/create?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      return data
    } else {
      const data = await Axios.put(
        `/api/permission/update?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      return data
    }
  } catch (error) {
    throw error
  }
}

export const requestDeletePermission = async payload => {
  try {
    const data = await Axios.delete(
      `/api/permission/delete?permissionId=${payload.id}`
    )
    return data
  } catch (error) {
    throw error
  }
}
